export const CAMPAIGN_REPORT_ID = 'campaign';
